module.exports = __webpack_public_path__ + "assets/img/2.2360a040.png";